<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange(page)"
                @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">
                    <el-button size="mini" type="primary" @click="handleAdd" icon="el-icon-plus" plain>
                        新增
                    </el-button>
                    <el-button size="mini" type="danger" @click="handleDel(scope.row)" icon="el-icon-delete" plain>
                        删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <!-- 查看 -->
                    <!-- <el-button size="mini" type="text" @click="handleView(scope.row)" icon="el-icon-view">
                        查看
                    </el-button> -->
                    <!-- 发放记录 -->
                    <el-button size="mini" type="text" @click="sendRecord(scope.row.id)" icon="el-icon-view">
                        发放记录
                    </el-button>
                    <!-- 编辑 -->
                    <el-button size="mini" type="text" @click="handleEdit(scope.row, scope.$index)" icon="el-icon-edit">
                        编辑
                    </el-button>
                    <!-- 删除 -->
                    <el-button size="mini" type="text" @click="handleDel(scope.row)" icon="el-icon-delete">
                        删除
                    </el-button>
                    <!-- 发放优惠券 -->
                    <el-button size="mini" type="text" @click="handleSend(scope.row)" icon="el-icon-circle-plus">
                        发放
                    </el-button>
                    <!-- 一键发放 -->
                    <el-button size="mini" type="text" @click="oneClickGrant(scope.row.id)" icon="el-icon-circle-plus">
                        一键发放
                    </el-button>
                </template>
                <template slot-scope="scope" slot="useType">
                    <span v-if="scope.row.useType == 0">通用</span>
                    <!-- scope.row.useType == 1时是产品，前面有个查看图标 -->
                    <el-button type="text" v-if="scope.row.useType == 1" icon="el-icon-view"
                        @click="handleViewGoods(scope.row)">产品</el-button>
                </template>
            </avue-crud>
            <el-dialog title="查看可用产品" :visible.sync="dialogVisibleGoods" width="70%" :close-on-click-modal="false">
                <el-table :data="goodsViewList" style="width: 100%" :border="true">
                    <el-table-column label="产品名称" prop="name"></el-table-column>
                    <el-table-column label="产品原价" prop="price"></el-table-column>
                    <el-table-column label="优惠金额" prop="discountAmount"></el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeDialogGoods">取消</el-button>
                </div>
            </el-dialog>
            <el-dialog :title="dialogVisibleTitle" :visible.sync="dialogVisible" width="70%"
                :close-on-click-modal="false">
                <el-form :model="form" label-width="120px" :rules="rules" ref="form">
                    <!-- 优惠券名称 -->
                    <el-form-item label="优惠券名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入优惠券名称" />
                    </el-form-item>
                    <!-- 优惠券类型 -->
                   <!--  <el-form-item label="优惠券类型" prop="type">
                        <el-radio-group v-model="form.type" @change="handleTypeChange">
                            <el-radio :label="0">优惠券</el-radio>
                            <el-radio :label="1">抵现券</el-radio>
                        </el-radio-group>
                    </el-form-item> -->
                    <!-- 优惠券抵现金额 -->
                    <el-form-item label="优惠券抵现金额" prop="price">
                        <div class="blockBox">
                            <el-input-number v-model="form.price" placeholder="请输入金额" :min="0" />
                            <span>元</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="优惠券有效期" prop="endDate">
                        <el-col :span="11">
                            <el-date-picker v-model="form.startDate" type="datetime" placeholder="开始日期"
                                value-format="timestamp" format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
                        </el-col>
                        <el-col class="line" :span="2">~</el-col>
                        <el-col :span="11">
                            <el-date-picker v-model="form.endDate" type="datetime" placeholder="结束日期"
                                value-format="timestamp" format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
                        </el-col>
                    </el-form-item>
                    <!-- 优惠券使用范围 -->
                    <!-- <el-form-item label="优惠券使用范围" prop="useType">
                        <el-radio-group v-show="form.type" v-model="form.useType">
                            <el-radio v-show="form.type == 1" :label="0">通用</el-radio>
                            <el-radio v-show="form.type == 0" :label="1">产品</el-radio>
                        </el-radio-group>
                        <el-radio-group v-show="!form.type" v-model="form.useType">
                            <el-radio :label="0">通用</el-radio>
                            <el-radio :label="1">产品</el-radio>
                        </el-radio-group>
                    </el-form-item> -->
                    <!-- 选择是否组合套餐 -->
                    <!-- <el-form-item v-if="form.type == 0" label="组合套餐" prop="combination">
                        <el-radio-group v-model="form.combination">
                            <el-radio :label="0">是</el-radio>
                            <el-radio :label="1">否</el-radio>
                        </el-radio-group>
                    </el-form-item> -->
                    <!-- 产品选择 -->
                    <!-- <el-form-item v-if="form.useType == 1" label="指定产品" prop="goodsList">
                        <el-button type="text" @click="isSelectorVisible = true" icon="el-icon-plus">选择产品</el-button>
                        <el-table :data="form.goodsList" style="width: 100%" :border="true"
                            v-if="form.goodsList.length">
                            <el-table-column label="产品名称" prop="name"></el-table-column>
                            <el-table-column label="产品原价" prop="price"></el-table-column>
                            <el-table-column label="优惠金额" prop="discountAmount">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.discountAmount" :min="1" />
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="handleDeleteProduct(scope.$index)"
                                        icon="el-icon-delete">
                                        删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <product-selector :visible.sync="isSelectorVisible" @confirm="handleProductSelection" />
                    </el-form-item> -->
                    <!-- prompt提示语 -->
                   <!--<el-form-item label="提示语" prop="prompt">
                        <el-input v-model="form.prompt" placeholder="请输入提示语" />
                    </el-form-item> -->
                    <!-- 优惠券使用说明 -->
                    <el-form-item label="优惠券使用说明" prop="remarks">
                        <el-input type="textarea" v-model="form.remarks" placeholder="请输入内容" rows="4" />
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer" v-if="dialogVisibleTitle !== '查看优惠券'">
                    <el-button type="primary" @click="handleSubmit">保存</el-button>
                    <el-button @click="dialogVisible = false">取消</el-button>
                </div>
            </el-dialog>
            <el-dialog title="发放优惠券" :visible.sync="sendDialogVisible" width="70%" :close-on-click-modal="false">
                <el-button size="mini" type="text" @click="sendDialogVisibleChild = true" icon="el-icon-plus">
                    选择商户
                </el-button>
                <el-table :data="sendForm.merchant" style="width: 100%" border>
                    <el-table-column label="商户名称" prop="shopName"></el-table-column>
                    <!-- 数量 -->
                    <el-table-column label="数量" prop="num">
                        <template slot-scope="scope">
                            <el-input-number v-model="scope.row.num" :min="1" />
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleDeleteMerchant(scope.$index)"
                                icon="el-icon-delete">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <shop-selector :visible.sync="sendDialogVisibleChild" @confirmShopSelector="handleShopSelection"
                    @update:visible="sendDialogVisibleChild = $event" />
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="handleSendSubmit">发放</el-button>
                    <el-button @click="sendDialogVisible = false">取消</el-button>
                </div>
            </el-dialog>
            <send-record :visibleRecord.sync="sendRecordVisible" :couponId="couponId" />
        </basic-container>
    </div>
</template>
<script>
import { couponOption } from "@/const/work/waterProof/couponOption";
import {
    getCouponList,
    getCouponDetail,
    addOrEditCoupon,
    delCoupon,
    sendCoupon,
    oneClickGrant
} from "@/api/work/waterProof/coupon";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import ProductSelector from "./components/productSelector/index.vue";
import ShopSelector from "./components/shopSelector/index.vue";
import SendRecord from "./components/sendRecord/index.vue";
export default {
    name: "coupon",
    components: {
        ProductSelector,
        ShopSelector,
        SendRecord
    },
    data() {
        return {
            tableOption: couponOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            loading: false,
            dialogVisible: false, // 控制弹窗显示
            dialogVisibleTitle: "", // 弹窗标题
            form: {
                name: "", // 优惠券名称
                type: 1, // 优惠券类型，默认值为优惠券
                price: 0, // 抵现券金额（如果是优惠券可以忽略）
                useType: 1, // 使用范围，默认值为通用
                combination: 0, // 是否组合套餐
                goodsList: [], // 可用产品（仅在选择“产品”时使用）
                startDate: '',
                endDate: '',
                prompt: "", // 提示语
                remarks: "", // 使用说明
            },
            goodsViewList: [], // 查看产品列表
            allGoodsList: [], // 所有商品列表
            dialogVisibleGoods: false, // 查看产品弹窗
            isSelectorVisible: false,
            sendDialogVisible: false, // 发放优惠券弹窗
            sendDialogVisibleChild: false, // 选择商户弹窗
            sendRecordVisible: false, // 发放记录弹窗
            couponId: "", // 优惠券id
            sendForm: [],
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10 //每页显示多少条
            },
            // 表单验证规则
            rules: {
                name: [
                    { required: true, message: "请输入优惠券名称", trigger: "blur" }
                ],
                type: [
                    { required: true, message: "请选择优惠券类型", trigger: "change" }
                ],
                price: [
                    { required: true, message: "请输入抵现金额", trigger: "blur" }
                ],

                useType: [
                    { required: true, message: "请选择优惠券使用范围", trigger: "change" }
                ],
                combination: [
                    { required: true, message: "请选择是否组合套餐", trigger: "change" }
                ],
                goodsList: [
                    {
                        required: true,
                        message: "请选择指定产品",
                        trigger: "change",
                        validator: (rule, value, callback) => {
                            if (this.form.useType == 1 && (!value || !value.length)) {
                                callback(new Error("产品不能为空"));
                            } else {
                                callback();
                            }
                        },
                    },
                ],
                startDate: [
                    { required: true, message: "请选择开始日期", trigger: "change" }
                ],
                endDate: [
                    { required: true, message: "请选择结束日期", trigger: "change" }
                ],
                remarks: [
                    { required: true, message: "请输入优惠券使用说明", trigger: "blur" }
                ],
            },
        };
    },
    created() {
        this.handleList();
    },
    mounted() { },
    computed: {},
    props: [],
    methods: {
        sendRecord(id) {
            this.couponId = id;
            this.sendRecordVisible = true;
        },
        closeSendRecordDialog() {
            this.sendRecordVisible = false;
        },
        handleViewGoods(row) {
            this.clean();
            getCouponDetail(row.id).then(res => {
                let data = JSON.parse(res.data);
                this.findPureWaterGoodsByRootDepartId(data.goodsList);
                this.dialogVisibleGoods = true;
            });
            this.dialogVisibleGoods = true;
        },
        closeDialogGoods() {
            this.dialogVisibleGoods = false;
        },
        handleTypeChange() {
            const val = this.form.type;
            if (val == 1) {
                this.form.useType = 0;
            }
            if (val == 0) {
                this.form.useType = 1;
            }
        },
        handleDeleteMerchant(index) {
            this.sendForm.merchant.splice(index, 1);
        },
        handleShopSelection(selectedShops) {
            // console.log("选中的商户：", selectedShops);
            selectedShops = selectedShops.map(item => ({
                ...item,
                num: 1
            }));
            // 优化商户去重逻辑，确保不会重复添加
            const newShops = selectedShops.filter(item => 
                !this.sendForm.merchant.some(merchant => merchant.id === item.id)
            );
            this.sendForm.merchant = this.sendForm.merchant.concat(newShops);
        },
        handleDeleteProduct(index) {
            this.form.goodsList.splice(index, 1);
        },
        handleProductSelection(selectedProducts) {
            // console.log("选中的产品：", selectedProducts);
            selectedProducts = selectedProducts.map(item => {
                return {
                    goodsId: item.id,
                    discountAmount: item.discountAmount,
                    price: item.price,
                    name: item.name
                };
            });
            // 在此处处理选中的产品数据
            if (this.form.goodsList.length > 0) {
                this.form.goodsList = this.form.goodsList.concat(selectedProducts.filter(item => {
                    return !this.form.goodsList.some(product => product.id === item.id || product.goodsId === item.id|| product.goodsId === item.goodsId);
                }));
                console.log('this.form.goodsList:::1 ', this.form.goodsList);
            } else {
                this.form.goodsList = selectedProducts;
            }
        },
        handleSendSubmit() {
            // console.log("发放优惠券：", this.sendForm);
            /* let params = {
                merchant: this.sendForm.merchant.map(item => item.id),
            }; */
            // let params是一个数组：[{"userId":"","num":12}]，其中userId是商户id，num是数量
            let params = this.sendForm.merchant.map(item => {
                return {
                    userId: item.id,
                    num: item.num
                };
            });
            console.log(this.sendForm.coupon,'params::: ', params);
            sendCoupon(this.sendForm.coupon, params).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "发放成功",
                        type: "success"
                    });
                    this.sendDialogVisible = false;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message ? res.message : '发放失败,请重试',
                        type: "error"
                    });
                }
            });
        },
        handleisSelectorVisible(val) {
            // console.log('val::: ', val);
            this.isSelectorVisible = val;
        },
        handleSend(row) {
            this.sendForm = {
                merchant: [], // 选择的商户
                coupon: row.id, // 选择的优惠券
            };
            this.sendDialogVisible = true;
        },
        oneClickGrant(id) {
            this.$confirm('确定要一键发放吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning' 
            }).then(() => {
                oneClickGrant(id).then(res => {
                    if (res.code == "200") {
                        this.$message({
                            showClose: true,
                            message: "发放成功",
                            type: "success"
                        }); 
                    } 
                }) 
            })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消一键发放'
                });
            });
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 表单校验通过，执行提交操作
                    // console.log("表单校验通过，提交表单：", this.form);
                    let params = {
                        ...this.form,
                        name: this.form.name,
                        type: this.form.type, 
                        price: this.form.price, // 抵现券金额（如果是优惠券可以忽略）
                        useType: this.form.useType, // 使用范围，默认值为通用
                        goodsList: [], // 可用产品（仅在选择“产品”时使用）
                        startDate: this.form.startDate,
                        endDate: this.form.endDate,
                        remarks: this.form.remarks, // 使用说明
                    };
                    // console.log("params::: ", params);
                    let isEdit = this.dialogVisibleTitle === "编辑优惠券";
                    addOrEditCoupon(params, isEdit).then(res => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success"
                            });
                            this.handleList();
                            this.dialogVisible = false;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message ? res.message : '操作失败,请重试',
                                type: "error"
                            });
                        }
                    });
                } else {
                    // console.log("表单校验失败");
                    return false;
                }
            });
        },
        handleAdd() {
            this.clean();
            this.dialogVisible = true;
            this.dialogVisibleTitle = "新增优惠券";
        },
        handleEdit(row) {
            this.clean();
            getCouponDetail(row.id).then(res => {
                let data = JSON.parse(res.data);
                // console.log('data::1 ', data);
                this.findPureWaterGoodsByRootDepartId(data.goodsList);
                this.dialogVisible = true;
                this.dialogVisibleTitle = "编辑优惠券";
                this.form = {
                    ...data,
                    id: row.id ? row.id : '', // 优惠券id
                    name: row.name, // 优惠券名称
                    type: row.type, // 优惠券类型，默认值为优惠券
                    price: row.price, // 抵现券金额（如果是优惠券可以忽略）
                    useType: row.useType, // 使用范围，默认值为通用
                    goodsList: this.form.goodsList, // 可用产品（仅在选择“产品”时使用）
                    startDate: row.startDate,
                    endDate: row.endDate,
                    remarks: row.remarks, // 使用说明
                };
            });
        },
        // 获取商品列表
        findPureWaterGoodsByRootDepartId(selectedGoods) {
            // console.log('selectedGoods::: ', selectedGoods);
            const type = 'WATERPROOF'
            findPureWaterGoodsByRootDepartId(type).then(res => {
                if (res.code === "200") {
                    let data = JSON.parse(res.data);
                    // console.log('data::: ', data);
                    if (data) {
                        this.allGoodsList = data;
                        // 初始化已选择的商品
                        this.form.goodsList = selectedGoods.map(item => ({
                            ...item,
                            goodsId: item.goodsId,
                            price: this.allGoodsList.find(g => g.id === item.goodsId) ? this.allGoodsList.find(g => g.id === item.goodsId).price : "",
                            name: this.allGoodsList.find(g => g.id === item.goodsId) ? this.allGoodsList.find(g => g.id === item.goodsId).name : ""
                        }));
                        this.goodsViewList = this.form.goodsList;
                        // console.log('this.form.goodsList::: ', this.form.goodsList);
                    } else {
                        this.allGoodsList = [];
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        handleView(row) {
            // console.log('row::: ', row);
            this.clean();
            getCouponDetail(row.id).then(res => {
                let data = JSON.parse(res.data);
                this.findPureWaterGoodsByRootDepartId(data.goodsList);
                this.dialogVisible = true;
                this.dialogVisibleTitle = "查看优惠券";
                this.form = {
                    ...data,
                    id: row.id ? row.id : '', // 优惠券id
                    name: row.name, // 优惠券名称
                    type: row.type, // 优惠券类型，默认值为优惠券
                    price: row.price, // 抵现券金额（如果是优惠券可以忽略）
                    useType: row.useType, // 使用范围，默认值为通用
                    goodsList: this.form.goodsList, // 可用产品（仅在选择“产品”时使用）
                    startDate: row.startDate,
                    endDate: row.endDate,
                    remarks: row.remarks, // 使用说明
                };
            });
        },
        clean() {
            this.form = {
                name: "", // 优惠券名称
                type: "", // 优惠券类型，默认值为优惠券
                price: 0, // 抵现券金额（如果是优惠券可以忽略）
                useType: "", // 使用范围，默认值为通用
                goodsList: [], // 可用产品（仅在选择“产品”时使用）
                startDate: '',
                endDate: '',
                remarks: "", // 使用说明
            };
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = this.page.currentPage;
            params.size = pageSize;
            this.downloadData = params;
            getCouponList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            this.downloadData = params;
            getCouponList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            getCouponList(params).then(res => {
                if (res.code != 500) {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                    this.tableData = [];
                }
            });
        },
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            this.downloadData = params;
            getCouponList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize
                };
                this.tableLoading = false;
            });
        },
        handleList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize
            };
            this.downloadData = params;
            getCouponList(params).then(res => {
                let data = JSON.parse(res.data);
                // console.log('data::: ', data);
                this.tableData = data.rows;
                console.log('this.tableData::: ', this.tableData);
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            });
            // this.getDepartment();
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange(val) {
            let ids = val.map(item => {
                return item.id;
            });
            this.ids = ids.join(",");
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(row) {
            let ids = "";
            ids = this.ids;
            if (row) {
                ids = row.id;
                this.$confirm(`您确定删除该条数据吗？`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        delCoupon(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功删除",
                                        type: "success"
                                    });
                                    this.handleList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message ? res.message : '删除失败,请重试',
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            } else {
                if (!ids) {
                    this.$message({
                        showClose: true,
                        message: "未选中任何数据",
                        type: "error"
                    });
                    return;
                }
                let length = ids.split(",").length;
                this.$confirm(
                    `共选中${length}条数据吗，您确定批量删除吗？`,
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                    .then(() => {
                        delCoupon(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功",
                                        type: "success"
                                    });
                                    this.handleList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.blockBox {
    display: flex;
    align-items: center;

    span {
        margin-left: 10px;
    }
}

.table-container {
    padding: 8px 10px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}

.line {
    text-align: center;
    line-height: 32px;
}

::v-deep .el-form-item__label {
    color: #606266 !important;
    font-weight: 700 !important;
}
</style>